import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {ResourceMenuTitles, ResourceTypeFilters} from "root/DataFunctions/Constants";

const ResourcesAppBodyHeader= (props) =>
{

    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case ResourceTypeFilters.ALL:
                return <h4 className="title">{ResourceMenuTitles.ALL}</h4>
                break;

            case ResourceTypeFilters.FEELINGS:
                return <h4 className="title">{ResourceMenuTitles.FEELINGS}</h4>
                break;

            case ResourceTypeFilters.GAME:
                return <h4 className="title">{ResourceMenuTitles.GAME}</h4>
                break;

            case ResourceTypeFilters.LEARNING:
                return <h4 className="title">{ResourceMenuTitles.LEARNING}</h4>
                break;

            case ResourceTypeFilters.HELP:
                return <h4 className="title">{ResourceMenuTitles.HELP}</h4>
                break;

            default:
                return <h4 className="title">{ResourceMenuTitles.FEELINGS}</h4>
                break;
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default ResourcesAppBodyHeader;
